import { AdapterRegistry, IModel, KustoDatabaseDataset, Metamodel } from 'shell-models-lib';
import { tabularPropertiesCommonAdapts } from 'app/model/adapters/datasets/tabular-type.dataset.adapter';
import { AzureDataExplorerDatasetAdapter } from 'app/model/adapters/datasets/azure-data-explorer-dataset.adapter';
import { Model } from 'app/model/backendmodel';
import { GlobalVariables } from 'app/services/globals';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(KustoDatabaseDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            linkedService: '*',
            connectionSettings: GlobalVariables.enableConnectionSettings ? '*' : undefined,
            typeProperties: {
                table: '*'
            }
        }
    }
})
export class KustoDatabaseDatasetAdapter extends AzureDataExplorerDatasetAdapter {
    protected override model(): IModel {
        return KustoDatabaseDataset.MODEL;
    }

    protected override async _toResource(dataset: KustoDatabaseDataset): Promise<Model.DatasetResource> {
        return (await super._toResource(dataset)) as Model.DatasetResource;
    }

    protected override async _toModel(
        modelDatasetResource: Model.DatasetResource,
        dataset?: KustoDatabaseDataset
    ): Promise<KustoDatabaseDataset> {
        return await super._toModel(modelDatasetResource, dataset);
    }
}
